module.exports = __webpack_public_path__ + "img/headImg.14d32508.png";